// BioPageHeader.jsx
// TK 9/29/2k22

// Packages, Dependencies, and Shared Libraries
import React from "react";
import { useNavigate } from "react-router-dom";

// Images
import logo from "../../Images/HomePage/LeafLings.png";
import instagramLogo from "../../Images/SocialMedia/instagram_glyph.png";
import SocialMediaIcon from "../../HomePage/SocialMediaIcon";

// Constants
import * as homePageConstants from "../../constants";

// CSS

/*******************************************************************************
 * @func PlantBioPageHeader (React Component)
 * This component has the logo and the social media icons that appear at the top
 *  of the page. Clicking on the logo takes the user home and clicking on the
 * social media icons takes them to the social media page.
 *
 * @param None
 * @return JSX Element
 *
 * @notes None
 *
 ******************************************************************************/
const BioPageHeader = () => {
  // Constants
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-global-bg/90 backdrop-blur-sm border-b border-leaf-brown/10">
      <div className="flex items-center justify-between mx-auto max-w-[600px] px-3 py-2">
        <img
          className="w-[130px] sm:w-[160px] cursor-pointer hover:opacity-80 transition-opacity"
          src={logo}
          alt="Leaflings"
          onClick={() => {
            navigate("/");
          }}
        />
        <div className="flex items-center gap-3 font-global">
          <nav className="flex items-center gap-3 font-bold text-sm text-leaf-green-dark">
            <button
              className="hover:text-leaf-green transition-colors"
              onClick={() => navigate("/game")}
            >
              Game
            </button>
            <button
              className="hover:text-leaf-green transition-colors"
              onClick={() => navigate("/me")}
            >
              My garden
            </button>
          </nav>
          <SocialMediaIcon
            logoRelPath={instagramLogo}
            link={homePageConstants.INSTAGRAM_URL}
          />
        </div>
      </div>
    </header>
  );
}; // End PlantBioPageHeader

export default BioPageHeader;
